// extracted by mini-css-extract-plugin
module.exports = {"root":"index_root__NsXBC","row":"index_row__PUpBD","label":"index_label__kjpCT","value":"index_value___Puji","valueExpire":"index_valueExpire__S9cvC"};